import { render } from "./BaseLink.vue?vue&type=template&id=f7e01c26&scoped=true"
import script from "./BaseLink.vue?vue&type=script&lang=js"
export * from "./BaseLink.vue?vue&type=script&lang=js"

import "./BaseLink.vue?vue&type=style&index=0&id=f7e01c26&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f7e01c26"

export default script